module.exports = __webpack_public_path__ + "a6ff714d9d60f384221e040dccc4e088.pdf";